/**
 * 재고 숫자 칸 — 누르면 그 숫자를 이루는 건들이 열린다 (v2.78.0 에 재고관리에서 태어남).
 *
 * ⭐**재고관리와 대시보드가 같은 부품을 쓴다**(v2.182.0). 대시보드 재고표에 납품예정·입고예정·
 *   임대·가용 칸이 생기면서 같은 모양이 두 곳에 필요해졌다 — 베껴 두면 한쪽만 고쳐져 어긋난다.
 *   ⚠여기를 `StockList.tsx` 안에 두고 대시보드가 끌어 쓰면 **대시보드 첫 화면이 재고관리 화면
 *     전체를 함께 내려받는다**(그 파일은 탭 5개짜리 큰 화면이다). 그래서 따로 둔다.
 *
 * ⭐0 은 누를 게 없으니 그냥 글씨로 둔다 (빈 팝업이 뜨는 것보다 낫다).
 * ⚠ 행 클릭(입·출고 내역)과 겹치므로 stopPropagation 필수.
 * ⚠ 칸 폭이 바뀌지 않게 글자 크기·자간을 건드리지 않는다 (숫자 그대로 + 밑줄만).
 */
export function DrillNum({
  value,
  onClick,
  title,
}: {
  value: number;
  onClick: () => void;
  title: string;
}) {
  if (!value) return <>{value}</>;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
      title={title}
      className="num underline decoration-dotted underline-offset-2 hover:decoration-solid hover:font-semibold"
    >
      {value}
    </button>
  );
}
